import _ from 'lodash'

export default {
	name : 'search-field',
	props : ['data'],
	data () {
		return {
			field : {
				fakeValue : this.data.fakeValue,
				value : this.data.value,
				active : false
			}
		}
	},
	methods : {
    getData: _.debounce(
      function (event) {

        let vm = this

        this.$emit('getData', event.target.value)

      }, 300),
		optionSelected (option) {

			let vm = this

			vm.field.fakeValue = option.fakeValue

			this.$emit('optionSelected', option.value)

		}
	}
}



// WEBPACK FOOTER //
// ./src/components/general/fields/search/script.js